
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"#767679","viewBox":"0 0 32 32","width":"14","height":"14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.5 5L5 9v16h5.5v3h3l3-3H21l6-6V5zM9 7h16v11l-3 3h-6l-3 3v-3H9zm5 4v6h2v-6zm5 0v6h2v-6z"}})])
          )
        }
      }
    